import { useEffect } from "react";
import { StAdjustmentsPreviewSidebar } from "./st-adjustments-preview-sidebar";
import { useStAdjustmentsSection } from "./st-adjustments-section";
import { TechnicianLinesSidebar } from "./technician-lines-sidebar";

/**
 * One technician's lines, for the page's shared sidebar.
 *
 * Reports its own open state upward so the page can widen the layout, and hands
 * back a close handler so dismissing the pane from the shell clears the row
 * selection here.
 */
export const StAdjustmentsSidebar = ({
  onOpenChange,
  registerClose,
}: {
  onOpenChange?: (open: boolean) => void;
  registerClose?: (close: (() => void) | null) => void;
} = {}) => {
  const {
    businessId,
    runId,
    isPreview,
    detailGroup,
    push,
    closeDetail,
    stagePushTechnician,
  } = useStAdjustmentsSection();

  useEffect(() => {
    registerClose?.(closeDetail);

    return () => registerClose?.(null);
  }, [closeDetail, registerClose]);

  useEffect(() => {
    onOpenChange?.(!!detailGroup);

    return () => onOpenChange?.(false);
  }, [detailGroup, onOpenChange]);

  return isPreview ? (
    <StAdjustmentsPreviewSidebar group={detailGroup} onClose={closeDetail} />
  ) : (
    <TechnicianLinesSidebar
      businessId={businessId}
      runId={runId}
      group={detailGroup}
      busy={push.isBusy}
      onClose={closeDetail}
      onPushTechnician={stagePushTechnician}
    />
  );
};
